module.exports = __webpack_public_path__ + "static/media/wafa.cb453065.png";